export default __webpack_public_path__ + "static/media/hörtest-avatar-04.e9ac19dc.svg";